<template>
  <Card
    class="z-10 md:z-auto w-full md:w-228 fixed md:sticky md:top-76 lg:top-112 bottom-0 left-0 border-t-1 md:border-0 border-solid border-grey-divider-subdued mr-32"
  >
    <h2 class="text-h3 pb-8 hidden md:inline-block">Adventures</h2>
    <p class="text-body pb-24 hidden md:inline-block">Create one-of-a-kind, at-home experiences designed for kids</p>
    <Button
      :value="hasDraft ? 'Edit Adventure' : 'Create Adventure'"
      size="medium"
      class="w-full mb-8"
      @click="createAdventureHandler"
    />
    <Popup v-model="popupState" popupHeader="Create a babysitter profile">
      <p class="text-body mb-16">You need a babysitter profile to create an Adventure</p>
      <Button value="Create Babysitter Profile" size="medium" class="w-full" href="/profile/provider/babysitter/new" />
    </Popup>
  </Card>
</template>

<script lang="ts">
import Button from '../../../../components/button/Button.vue';
import Card from '../../../../components/card/Card.vue';
import Popup from '../../../../components/popup/Popup.vue';

export default {
  name: 'CreateAdventureCTA',
  components: { Card, Button, Popup },
  props: {
    hasSitterProfile: {
      type: Boolean,
      default: false,
    },
    hasDraft: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      popupState: false,
    };
  },
  methods: {
    createAdventureHandler(): void {
      if (this.hasSitterProfile) this.$router.push({ path: '/adventures/new/category' });
      else this.popupState = true;
    },
  },
};
</script>
